<script lang="ts" setup>
import type { GridModule } from '@integration-layer/ampliance/schemas/grid-module-schema.localized'
import type { EditorialGridModuleProps } from '@design-system/components/Editorial/EditorialGridModule.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: GridModule
}>()

const data = await useComponentResponse<GridModule>(props)
</script>

<template>
  <EditorialGridModule
    v-if="data"
    v-bind="data as unknown as EditorialGridModuleProps"
  />
</template>
